import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/settings/settings.service';
import { AuthService } from "../../../shared/authentication/auth.service";
import { User } from "../../users/user";
import { TranslateService } from 'ng2-translate/ng2-translate';
import { CustomValidators } from 'ng2-validation';


@Component({
    selector: 'app-login',
    templateUrl: 'resetPassword.component.html',
    styleUrls: ['resetPassword.component.scss'],
})
export class resetPasswordComponent implements OnInit, OnDestroy {

    me: User;
    errorMessage: string;
    valForm: FormGroup;

    showError = false;
    inProgress = false;

    private subscriptions = [];

    constructor(
          public settings: SettingsService,
          private authService: AuthService,
          private router: Router,
          private translate: TranslateService,
          fb: FormBuilder
        ) {

        this.valForm = fb.group({
            'id': [null, Validators.compose([Validators.required])]
        });

        translate.setDefaultLang('en');
        this.setLanguage();
    }

    setLanguage() {
        let availableLangs = this.translate.getLangs();
        let browserLang = this.translate.getBrowserCultureLang();
        if(availableLangs.indexOf(browserLang) != -1) {
            this.translate.use(browserLang);
        }
    }

    submitForm($ev, value: any) {
        $ev.preventDefault();
        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }
        if (this.valForm.valid) {
            this.inProgress = true;
            var subReset = this.authService.forgotPassword(this.valForm.value.id)
                .subscribe(
                    result => {
                        this.inProgress = false;
                        this.router.navigate(['/login/change'])
                        this.showError = false;
                    },
                    error =>  {
                        this.inProgress = false;
                        this.errorMessage = <any>error;
                        this.showError = true;
                    }
              );
            this.subscriptions.push(subReset);
        }
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/pages/resetPassword/resetPassword.component.ts